export default {
  fullNav: true,
  hideFooter: false,
  isDark: false,
};
